import { useEffect, useState } from "react";
import { Form } from "@/components/Form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getSelectUnities } from "@/Api/unities";

type UnityOption = { id: number | string; name: string };

type UnitySelectFieldProps = {
  name?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export const UnitySelectField = ({
  name = "unity_id",
  disabled,
  onChange,
}: UnitySelectFieldProps) => {
  const [unities, setUnities] = useState<UnityOption[]>([]);

  useEffect(() => {
    getSelectUnities().then(({ data }) => setUnities(data?.response || []));
  }, []);

  return (
    <Form.Field name={name}>
      {({ field }) => (
        <Form.Item>
          <Form.Label>
            Unidade <Form.Message />
          </Form.Label>
          <Select
            disabled={disabled}
            value={field.value ? String(field.value) : ""}
            onValueChange={(value) => {
              field.onChange(value);
              onChange?.(value);
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione uma unidade" />
            </SelectTrigger>
            <SelectContent>
              {unities.map((unity) => (
                <SelectItem key={unity.id} value={String(unity.id)}>
                  {unity.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Form.Item>
      )}
    </Form.Field>
  );
};
